var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useQuery } from "@apollo/client";
import { Id } from "core/utils";
import React, { useState } from "react";
import styled from "styled-components";
import { Content } from "./Content";
import { UserInput } from "./UserInput";
import { Movies, PopularPrograms } from "./blocks";
import { AllPrograms } from "./blocks/AllPrograms";
import { ComingSoonPrograms } from "./blocks/ComingSoonPrograms";
import { SearchForm } from "./blocks/SearchForm";
import { SearchResults } from "./blocks/SearchResults";
import { query } from "./blocks/SearchResults/query";
export var ProgramOverviewPage = function () {
    var _a = useState(UserInput.initial), userInput = _a[0], setUserInput = _a[1];
    var variables = UserInput.toQueryVariables(userInput);
    var channel = variables.channel;
    var queryResult = useQuery(query, {
        variables: variables,
        skip: UserInput.toSkipQuery(userInput),
    });
    return (React.createElement(ProgramsStyled, { "data-component": Id.component.programsPage.container },
        React.createElement(SearchForm, { userInput: userInput, setUserInput: setUserInput }),
        React.createElement(Content, __assign({}, { userInput: userInput }),
            React.createElement(SearchResults, __assign({ userInput: userInput }, { queryResult: queryResult })),
            React.createElement(PopularPrograms, null),
            UserInput.isMoviesVisible(userInput) && React.createElement(Movies, __assign({}, { channel: channel })),
            React.createElement(ComingSoonPrograms, { userInput: userInput }),
            React.createElement(AllPrograms, { userInput: userInput }))));
};
var ProgramsStyled = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  min-height: 100vh;\n"], ["\n  width: 100%;\n  min-height: 100vh;\n"])));
var templateObject_1;
